(() => {
  function notify(text) {
    let notificationKey = 'ui.data-copy.text.default';
    const emailRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)*$/;
    const telRegex = /^[\d\s+\-()]+$/;

    switch (true) {
      default:
        break;

      case emailRegex.test(text):
        notificationKey = 'ui.data-copy.text.email';
        break;

      case telRegex.test(text):
        notificationKey = 'ui.data-copy.text.tel';
        break;

      case text.indexOf('://') > -1:
        notificationKey = 'ui.data-copy.text.url';
        break;
    }

    window.swinger.i18n()
      .then((i18n) => {
        window.swinger.snackbar.create({
          isSelfclosing: true,
          children: [
            {
              component: 'notification',
              data: {
                type: 'copy',
                text: i18n(notificationKey, { text }),
              },
            },
          ],
        });
      })
      .catch(console.info);
  }

  function copy(text, showNotification = true) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text)
        .then(() => {
          if (!showNotification) {
            return;
          }
          window.swinger.clipboard.notify(text);
        })
        .catch(console.info);
    }
  }

  function copyRichText(html, showNotification = true) {
    const htmlContent = html;
    // Create a temporary element to hold the HTML content
    const tempElement = document.createElement('div');
    tempElement.innerHTML = htmlContent;
    document.body.appendChild(tempElement);
    // Select the HTML content
    const range = document.createRange();
    range.selectNode(tempElement);
    // Copy the selected HTML content to the clipboard
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    document.execCommand('copy');
    selection.removeAllRanges();
    document.body.removeChild(tempElement);

    if (!showNotification) {
      return;
    }

    window.swinger.i18n()
      .then((i18n) => {
        window.swinger.clipboard.notify(i18n('ui.data-copy.text.default'));
      })
      .catch(console.info);
  }

  window.swinger = window.swinger || {};
  window.swinger.clipboard = {
    copy,
    copyRichText,
    notify,
  };
})();
